<template>
    <div class="card-masonry">
        <div v-if="isAdmin" class="card-options-groupon">
            <div class="mdc-checkbox__container">
                <div class="mdc-checkbox">
                    <input type="checkbox"
                           class="mdc-checkbox__native-control"
                           id="admin-publish-content"
                           v-model="checked"/>
                    <div class="mdc-checkbox__background">
                        <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                            <path class="mdc-checkbox__checkmark-path" fill="none"
                                  d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                        </svg>
                        <div class="mdc-checkbox__mixedmark"></div>
                    </div>
                </div>
                <label for="admin-publish-content">顯示未發佈優惠</label>
            </div>
        </div>
        <div class="popsale-card-sizer"></div>
        <card-masonry-body v-if="cards" v-for="card in cards" :key="card.id" :card="card" :category="category"
                           :is-admin="isAdmin" :is-google-ads="card.isGoogleAds"></card-masonry-body>
        <div v-show="!cards.length && !isLoading" class="popsale-card-empty">
            <div class="popsale-card-empty__container mdc-elevation--z1">
                <span class="mdc-typography--headline6">沒有任何資料</span>
            </div>
        </div>
    </div>
</template>

<script>
    import CardMasonryBody from "./card-masonry-body";

    export default {
        components: {CardMasonryBody},
        props: {
            'isAdmin': {
                required: true,
                default: false,
            }
        },
        data() {
            return {
                checked: false,
                initRequest: null,
                currentUrl: null,
                previousPage: null,
                previous: null,
                next: null,
                nextPage: null,
                isLoading: false,
                cards: [],
                category: 0,
                grid: null,
                snackBar: $('.mdc-snackbar')[0].MDCSnackbar,
                currentRequest: null,
            }
        },
        methods: {
            init: function () {
                this.infiniteScroll();

                this.grid = $('.card-masonry').masonry({
                    itemSelector: '.popsale-card-item',
                    columnWidth: '.popsale-card-sizer',
                    horizontalOrder: true,
                    percentPosition: true
                });
            },
            request: function (url, isPrevious = false) {
                if (!url) {
                    if (this.previousPage !== 1) {
                        popsale.snackText("沒有新資料");
                    }
                    return
                }

                if (this.isLoading) {
                    return;
                }

                this.isLoading = true;

                if (this.currentRequest) {
                    this.currentRequest.abort();
                }

                this.currentRequest = popsale.formRequest(url, 'get', null, function (response) {
                    this.isLoading = false;

                    if (!response.hasOwnProperty('current_page')) {
                        return;
                    }

                    let page = response.current_page;

                    if (!this.previousPage || page < this.previousPage && response.hasOwnProperty('prev_page_url')) {
                        this.previousPage = page;
                        this.previous = response.prev_page_url;
                    }

                    if (page >= this.nextPage && response.hasOwnProperty('next_page_url')) {
                        this.nextPage = page;
                        this.next = response.next_page_url;
                    }

                    this.currentUrl = url;

                    const ads = {
                        "isGoogleAds": true
                    };

                    if (isPrevious) {
                        $.each(response.data.reverse(), function (index, value) {

                            if (index === response.data.length - 1) {
                                if (response.advertise) {
                                    response.advertise.isAd = true;
                                    this.cards.unshift(response.advertise);
                                }
                            } else if (index === response.data.length - 4) {
                                this.cards.unshift(ads);
                            }
                            this.cards.unshift(value)
                        })
                    } else {
                        $.each(response.data, function (index, value) {
                            if (index === 1) {
                                if (response.advertise) {
                                    response.advertise.isAd = true;
                                    this.cards.push(response.advertise);
                                }
                            } else if (index === 4) {
                                this.cards.push(ads);
                            }
                            this.cards.push(value);
                        }.bind(this));
                    }

                    this.grid.imagesLoaded(function () {
                        this.isProgress(false);
                    }.bind(this));

                }.bind(this));
            },
            infiniteScroll: function () {
                $(document).scroll(function () {
                    if ($(window).scrollTop() >= ($(document).height() - $(window).height()) * 0.7 && !this.isLoading) {
                        this.request(this.next);
                    }
                }.bind(this));
            },
            isProgress: function (show) {
                this.isLoading = show;
                let progress = $('.mdc-linear-progress')[0].MDCLinearProgress;

                if (progress === 'undefined') {
                    return;
                }

                if (show) {
                    progress.open();
                } else {
                    progress.close();
                }
            },
            setSnackBarTest: function (text) {
                $('.mdc-snackbar__label').text(text);
            }
        },
        mounted() {
            $(function () {
                this.init();
            }.bind(this));

            $(window).on('unload', function () {
                let date = new Date();
                date.setTime(date.getTime() + (5 * 60 * 1000)); // 5 mins

                Cookies.set('card-masonry-last-url', this.currentUrl, {expires: date});
                alert('Bye.');
            }.bind(this));
        },
        watch: {
            initRequest: function (newVal) {
                this.currentUrl = null;
                this.previousPage = null;
                this.previous = null;
                this.next = null;
                this.nextPage = null;
                this.cards = [];
                this.isLoading = false;
                this.request(newVal);
                $('.card-masonry')[0].scrollIntoView(true);

                let scrolledY = window.scrollY;
                if (scrolledY) {
                    window.scroll(0, scrolledY - 116);
                }
            },
            checked: function () {
                this.initRequest = this.initRequest + "&show_hidden=" + this.checked;
            }
        }
    }
</script>

<style lang="scss">
    .popsale-card-sizer, .popsale-card-item {
        width: 25%;
        @media (max-width: 900px) {
            width: 33.333%;
        }
        @media (max-width: 480px) {
            width: 50%;
        }
        @media (max-width: 300px) {
            width: 100%;
        }
    }

    .popsale-card-empty {
        display: flex;
        justify-content: center;

        &__container {
            background: var(--mdc-theme-primary);
            flex-basis: 70%;
            border-radius: 5px;
            text-align: center;
            color: white;
        }
    }

    .card-options-groupon {
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background: var(--mdc-theme-primary);
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;

        .mdc-checkbox__container {
            align-items: center;
            display: flex;
            border-radius: 3px;
            padding-right: 8px;
            color: white;

            .mdc-checkbox__background {
                border-color: white !important;
            }

            .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
                border-color: white !important;
                background-color: transparent !important;
            }
        }
    }
</style>